import type { AssetId } from '../schema';

/** Generates a new client asset IDs associated with the promise that returns the server generated value. */
export default function generateAssetId() {
    return `:${Date.now()}${Math.floor(Math.random() * 1000)}` as AssetId;
}
